
import { NavLink } from "react-router-dom"
import { route, publicUrlFor } from "../../../../globals/constants"
import FastImage from "../../../../globals/elements/fastimg"
import Service1 from "./service1";
import Service2 from "./service2";
import Service3 from "./service3";
import Service4 from "./service4";
import Service5 from "./service5";
import Service6 from "./service6";
export default function Service({
    options,
    data 
}) {

    const type = options.type ; // 1 2 3 4

    if(type === 1) {
        return <Service1
            options={options}
            data={data}
        />
    }

    if(type === 2) {
        return <Service2 
                options={options}
                data={data}
        />
    }

    if(type === 3) {
        return <Service3 
                options={options}
                data={data}
        />
    }

    if(type === 4) {
        return <Service4
                options={options}
                data={data}
        />
    }

    if(type === 5) {
        return <Service5
                options={options}
                data={data}
        />
    }

    if(type === 6) {
        return (
            <Service6 
                options={options}
                data={data}
            />
        )
    }

    return (
        <div></div>
    )
}
